import React, { Component } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    Button,
    Box,
    Typography,
    Divider,
    IconButton,
    Slide,
    Paper
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Close, Event, Schedule } from '@mui/icons-material';

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import AdminAPI from '../service/AdminAPI';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import Events from '../service/Events';

dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Paris");

dayjs.extend(utc);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class UpdateShopOpenings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            cachedProducts: null,
            products: [],
            startDate: dayjs(new Date()),
            endDate: dayjs(new Date())
        }
    }

    handleShow = (title) => this.setState({ show: true, title });

    handleClose = () => {
        this.setState({ show: false });
        this.props.onClose();
    }

    handleSubmit = (ev) => {
        ev.preventDefault();
        
        AdminAPI.UpdateStoreOpeningTimes(dayjs(this.state.startDate).tz("Europe/Paris"), dayjs(this.state.endDate).tz("Europe/Paris"))
            .then(() => window.location.reload())
            .catch(console.error);
    }

    componentDidUpdate() {
        if (this.state.show !== this.props.show) {
            this.setState({ show: this.props.show, startDate: this.props.startDate, endDate: this.props.endDate });
        }
    }

    handleChangeStartDate = (newVal) => {
        if(newVal > this.state.endDate) {
            Events.onResult.emit("error", "Anfangsdatum ist größer als Enddatum!");
            return;
        }

        this.setState({ startDate: newVal });
    }

    handleChangeEndDate = (newVal) => {
        if(newVal < this.state.startDate) {
            Events.onResult.emit("error", "Enddatum ist kleiner als Anfangsdatum!");
            return;
        }

        this.setState({ endDate: newVal });
    }

    renderDateInput = (params) => {
        return (
            <TextField 
                {...params} 
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-root': {
                        bgcolor: 'white',
                        borderRadius: '10px',
                        '&:hover fieldset': {
                            borderColor: '#2e7d32',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#2e7d32',
                        },
                    }
                }}
            />
        );
    }

    render() {
        return (
            <Dialog
                open={this.state.show}
                onClose={this.handleClose}
                TransitionComponent={Transition}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: { xs: '12px', sm: '20px' },
                        position: 'relative',
                        margin: { xs: '16px', sm: '32px' },
                        maxHeight: { xs: 'calc(100vh - 32px)', sm: '90vh' }
                    }
                }}
            >
                {/* Close Button */}
                <IconButton
                    onClick={this.handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: '#666',
                        zIndex: 1
                    }}
                >
                    <Close />
                </IconButton>

                {/* Header with gradient */}
                <Box
                    sx={{
                        background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                        pt: { xs: 3, sm: 4 },
                        pb: { xs: 2.5, sm: 3 },
                        px: { xs: 2, sm: 3 },
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2 } }}>
                        <Event sx={{ fontSize: { xs: '1.8rem', sm: '2.5rem' } }} />
                        <DialogTitle sx={{ p: 0 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', fontSize: { xs: '1.5rem', sm: '2rem' } }}>
                                Öffnungszeiten
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5, fontSize: { xs: '0.8rem', sm: '0.875rem' } }}>
                                Bestellzeitraum anpassen
                            </Typography>
                        </DialogTitle>
                    </Box>
                </Box>

                <DialogContent sx={{ pt: { xs: 2.5, sm: 4 }, pb: { xs: 2, sm: 3 }, px: { xs: 2, sm: 3 } }}>
                    <form onSubmit={this.handleSubmit} id="shop-times-form">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {/* Start Date Section */}
                            <Paper
                                elevation={0}
                                sx={{
                                    bgcolor: '#e8f5e9',
                                    borderRadius: '12px',
                                    p: 2.5,
                                    mb: 3,
                                    border: '2px solid #c8e6c9'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                    <Schedule sx={{ color: '#2e7d32' }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1b5e20' }}>
                                        Startdatum & Uhrzeit
                                    </Typography>
                                </Box>
                                <DateTimePicker
                                    maxDate={this.state.endDate}
                                    label="Bestellungen öffnen ab"
                                    value={this.state.startDate}
                                    onChange={this.handleChangeStartDate}
                                    renderInput={this.renderDateInput}
                                />
                            </Paper>

                            {/* End Date Section */}
                            <Paper
                                elevation={0}
                                sx={{
                                    bgcolor: '#e8f5e9',
                                    borderRadius: '12px',
                                    p: 2.5,
                                    border: '2px solid #c8e6c9'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                    <Schedule sx={{ color: '#2e7d32' }} />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#1b5e20' }}>
                                        Enddatum & Uhrzeit
                                    </Typography>
                                </Box>
                                <DateTimePicker
                                    minDate={this.state.startDate}
                                    label="Bestellungen schließen am"
                                    value={this.state.endDate}
                                    onChange={this.handleChangeEndDate}
                                    renderInput={this.renderDateInput}
                                />
                            </Paper>
                        </LocalizationProvider>
                    </form>
                </DialogContent>

                <Divider />

                <DialogActions sx={{ 
                    p: { xs: 2, sm: 3 }, 
                    gap: { xs: 1.5, sm: 2 },
                    flexDirection: { xs: 'column', sm: 'row' }
                }}>
                    <Button
                        onClick={this.handleClose}
                        variant="outlined"
                        size="large"
                        fullWidth
                        sx={{
                            borderRadius: '10px',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderColor: '#ddd',
                            color: '#666',
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            py: { xs: 1.2, sm: 1.5 },
                            order: { xs: 2, sm: 1 },
                            '&:hover': {
                                borderColor: '#bbb',
                                bgcolor: '#f5f5f5'
                            }
                        }}
                    >
                        Abbrechen
                    </Button>
                    <Button
                        type="submit"
                        form="shop-times-form"
                        variant="contained"
                        size="large"
                        fullWidth
                        startIcon={<Event />}
                        sx={{
                            bgcolor: '#2e7d32',
                            color: 'white',
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: { xs: '0.9rem', sm: '1.1rem' },
                            py: { xs: 1.2, sm: 1.5 },
                            borderRadius: '10px',
                            boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                            order: { xs: 1, sm: 2 },
                            '&:hover': {
                                bgcolor: '#1b5e20',
                                boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                transform: 'translateY(-2px)'
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Öffnungszeiten aktualisieren
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default UpdateShopOpenings;